module.exports = __webpack_public_path__ + "static/gauth-cd65ba33665359c855d3c0eaf8a62d53.jpeg";